<!--
Local Notification - Museum specific
-->

<template>
	<section
		aria-label="Notification."
		aria-live="assertive"
		class="c-notification"
		v-if="isVisible"
	>
		<!-- allow this notice to be dismissed, it interrupts screen-readers -->
		<div class="c-notification__container">
			<div
				v-if="eligibleNotifications.length"
				class="c-notification__text"
				v-html="eligibleNotifications[0].notification"
			></div>
			<button
				class="c-notification__action"
				v-on:click="close"
			>
				<span class="h-accessibility">Close this notice.</span>
				<span class="icon i-close i-close--small" aria-hidden="true">
					<crossIcon />
				</span>
			</button>
		</div>
	</section>
</template>

<script>
	import crossIcon from '/web/static/images/svgs/icon-cross.svg?component';

	export default {
		name: "local-notification",
		data: function () {
			return {
				eligibleNotifications: [],
				isVisible: false,
				updatedAt: null,
			};
		},
		props: {
			notificationsData: {
				type: String,
			},
			slug: {
				type: String,
				default: "museum"
			}
		},
		components: {
			crossIcon
		},
		computed: {
			notificationsArray: function () {
				return this.notificationsData ? JSON.parse(this.notificationsData) : null;
			}
		},
		created() {
			this.getNotification();
		},
		beforeMount() {
			this.showNotification();
		},
		methods: {
			getNotification: function () {
				for (let notification of this.notificationsArray) {
					if(this.eligibleNotifications.length < 1) { // we only show one notification
						let eligible = true;
						const currentDate = Math.round(+new Date() / 1000);

						if(notification.start) { // if start is populated
							let startDateTimestamp = Math.floor(
								new Date(notification.start).getTime() / 1000
							)

							// if start date is in future skip this notification
							if (startDateTimestamp > currentDate) {
								eligible = false;
							}
						}

						if(notification.end) { // if end is populated
							let endDateTimestamp = Math.floor(
								new Date(notification.end).getTime() / 1000
							)

							// if end date is in past skip this notification
							if (endDateTimestamp < currentDate) {
								eligible = false;
							}
						}

						// if still eligible add to eligibleNotifications array
						if(eligible) {
							this.eligibleNotifications.push(notification);
						}
					} else {
						break;
					}
				}
			},
			setVisited: function () {
				localStorage.setItem(`sc-${this.slug}-notification:closed`, this.updatedAt);
			},
			getVisited: function () {
				return parseInt(localStorage.getItem(`sc-${this.slug}-notification:closed`));
			},
			removeVisited: function () {
				localStorage.removeItem(`sc-${this.slug}-notification:closed`);
			},
			showNotification: function () {
				if(this.eligibleNotifications.length) {
					// set updatedAt
					let updatedAtTimestamp = Math.floor(
						new Date(this.eligibleNotifications[0].dateUpdated).getTime() / 1000
					);
					this.updatedAt = updatedAtTimestamp;

					// set isVisible
					if (!this.getVisited()) {
						this.isVisible = true;
					} else if (this.getVisited() !== this.updatedAt) {
						this.removeVisited();
						this.isVisible = true;
					}
				}
			},
			close: function () {
				this.setVisited();
				this.isVisible = false;
			}
		}
	};
</script>
